/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VendorLevelProfile } from '../models/VendorLevelProfile';
import type { VendorLevelProfileType } from '../models/VendorLevelProfileType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VendorLevelProfileService {

    /**
     * Get list of Vendor Level Profiles
     * @returns VendorLevelProfile Success
     * @throws ApiError
     */
    public static listVendorLevelProfiles({
        planId,
        type,
    }: {
        /**
         * Plan Id
         */
        planId?: number,
        /**
         * Vendor Level Type
         */
        type?: VendorLevelProfileType,
    }): CancelablePromise<Array<VendorLevelProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/vendorLevelProfile',
            query: {
                'planId': planId,
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

}
